import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Product } from '../models/product.model';

interface SwitchProductResponse {
  access_token: string;
  user: Record<string, unknown>;
}

@Injectable({ providedIn: 'root' })
export class ProductService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  private readonly productsSubject = new BehaviorSubject<Product[]>([]);
  readonly products$ = this.productsSubject.asObservable();

  private readonly activeProductSubject = new BehaviorSubject<Product | null>(null);
  readonly activeProduct$ = this.activeProductSubject.asObservable();

  setProducts(products: Product[]): void {
    this.productsSubject.next(products);
  }

  setActiveProduct(product: Product | null): void {
    this.activeProductSubject.next(product);
  }

  getActiveProduct(): Product | null {
    return this.activeProductSubject.value;
  }

  switchProduct(productId: number): Observable<SwitchProductResponse> {
    return this.http
      .post<SwitchProductResponse>(
        `${this.apiUrl}/admin/auth/switch-product`,
        { productId },
      )
      .pipe(
        tap((response) => {
          // Salvar novo JWT que contém o contexto do produto selecionado
          localStorage.setItem('sv_access_token', response.access_token);

          const target = this.productsSubject.value.find((p) => p.id === productId);
          if (target) {
            this.activeProductSubject.next(target);
          }

          // Recarregar para que todos os dados reflitam o novo produto
          window.location.reload();
        }),
      );
  }

  clear(): void {
    this.productsSubject.next([]);
    this.activeProductSubject.next(null);
  }
}
